// extracted by mini-css-extract-plugin
module.exports = {"border":"TableData_border__E6iFj","container":"TableData_container__3Hr1v"};